import { Colors, Lightning } from '@lightningjs/sdk';
import Button, { ButtonTemplateSpec } from 'components/common/buttons/Button';
import { getFontFaceFromStyle } from 'support/textUtils';
import { getImageTextureObj } from 'support/generalUtils';

export interface CheckmarkTextTemplateSpec extends ButtonTemplateSpec {
  isSelected: boolean;
  iconSize: number;
}

export default class CheckmarkText
  extends Button<CheckmarkTextTemplateSpec>
  implements
    Lightning.Component.ImplementTemplateSpec<CheckmarkTextTemplateSpec>
{
  private _isSelected = false;
  private _iconSize = 18;

  override _buttonClass = 'CheckmarkText';
  override _margin = 12;

  override get title() {
    return this.label;
  }

  get iconSize() {
    return this._iconSize;
  }

  set iconSize(value: number) {
    this._iconSize = value;
    this.updateIcons();
  }

  get isSelected() {
    return this._isSelected;
  }

  set isSelected(isSelected: CheckmarkTextTemplateSpec['isSelected']) {
    this._isSelected = isSelected;
    this.updateIcons();
  }

  static override _template(): Lightning.Component.Template<CheckmarkTextTemplateSpec> {
    return {
      ...super._template(),
      h: 29,
      flex: {
        direction: 'row',
        alignItems: 'center',
      },
    };
  }

  override _setup() {
    super._setup();
    this.paddingH = 0;
    this.backgroundColor = {
      unfocused: Colors('transparent').get(),
    };
    this._Label.patch({ text: { fontFace: getFontFaceFromStyle('regular') } });
  }

  override updateButtonWidth() {
    this.stage.update();

    const hasStartIcon = !!this._StartIcon.texture?._source?.lookupId;
    const startMargin = hasStartIcon ? this.margin : 0;

    const newWidth = this._StartIcon.finalW + startMargin + this._Label.finalW;

    this.setSmooth('w', Math.max(this.minWidth, newWidth));
    this._Label.patch({
      flexItem: { marginLeft: startMargin },
    });
  }

  private updateIcons() {
    const SELECTED_ICON_FOCUSED = getImageTextureObj(
      'static/images/playback/cc_selected_icon.svg',
      this.iconSize,
      this.iconSize,
    );
    const SELECTED_ICON_UNFOCUSED = getImageTextureObj(
      'static/images/playback/cc_selected_inverse_icon.svg',
      this.iconSize,
      this.iconSize,
    );

    this.setStartIcon(
      this.isSelected ? SELECTED_ICON_FOCUSED : SELECTED_ICON_UNFOCUSED,
    );
  }
}
